// import Vue from 'vue'
import Home from '@/views/Home.vue'
import Router from 'vue-router'

// Vue.use(Router)
//防止路由重复报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
//路由
export const constantRouterMap = [
    {
        path: '/',
        component: Home,
        children: [
            {
                path: '/',
                component: () => import("@/views/index/Index.vue"),
                meta: {
                    title: "首页",
                    id: 0,
                    fatherId: 0,
                }
            },
            {
                path: '/about',
                component: () => import("@/views/about/About.vue"),
                meta: {
                    title: "关于我们",
                    id: 1,
                    fatherId: 1
                },
                children: [
                    {
                        path: "/aboutContent",
                        component: () => import("@/views/about/AboutContent.vue"),
                        meta: {
                            title: "企业简介",
                            id: 6,
                            fatherId: 1
                        },
                    },
                    {
                        path: "/aboutHonor",
                        component: () => import("@/views/about/AboutHonor.vue"),
                        meta: {
                            title: "荣誉资质",
                            id: 8,
                            fatherId: 1
                        },
                    },
                    {
                        path: "/aboutHistory",
                        component: () => import("@/views/about/AboutHistory.vue"),
                        meta: {
                            title: "发展历程",
                            id: 9,
                            fatherId: 1
                        },
                    },
                    {
                        path: "/aboutCorporate",
                        component: () => import("@/views/about/AboutCorporate.vue"),
                        meta: {
                            title: "企业风采",
                            id: 7,
                            fatherId: 1
                        },
                    },
                ]
            },
            {
                path: '/template',
                component: () => import("@/views/Template.vue"),
                meta: {
                    title: "产品中心",
                    id: 2,
                    fatherId: 2
                }
            },
            {
                path: '/search',
                component: () => import("@/views/Search.vue"),
                meta: {
                    title: "搜索",
                    id: 999999,
                    fatherId: 999999
                }
            },
            {
                path: '/product',
                component: () => import("@/views/product/Product.vue"),
                meta: {
                    title: "产品中心",
                    id: 2,
                    fatherId: 2
                }
            },
            {
                path: '/productDetail',
                component: () => import("@/views/product/ProductDetail.vue"),
                meta: {
                    title: "产品中心详情",
                    id: 2,
                    fatherId: 2
                }
            },
            {
                path: '/application',
                component: () => import("@/views/application/Application.vue"),
                meta: {
                    title: "应用方向",
                    id: 3,
                    fatherId: 3
                }
            },
            {
                path: '/news',
                component: () => import("@/views/news/News.vue"),
                meta: {
                    title: "新闻中心",
                    id: 4,
                    fatherId: 4
                }
            },
            {
                path: '/newsDetail',
                component: () => import("@/views/news/NewsDetail.vue"),
                meta: {
                    title: "新闻中心详情",
                    id: 4,
                    fatherId: 4
                }
            },
            {
                path: '/article',
                component: () => import("@/views/article/Article.vue"),
                meta: {
                    title: "文章专栏",
                    id: 22,
                    fatherId: 22
                }
            },
            {
                path: '/articleDetail',
                component: () => import("@/views/article/ArticleDetail.vue"),
                meta: {
                    title: "文章专栏详情",
                    id: 22,
                    fatherId: 22
                }
            },
            {
                path: '/contact',
                component: () => import("@/views/contact/Contact.vue"),
                meta: {
                    title: "联系我们",
                    id: 5,
                    fatherId: 5
                },
                children: [
                    {
                        path: "/contactUs",
                        component: () => import("@/views/contact/ContactUs.vue"),
                        meta: {
                            title: "联系方式",
                            id: 13,
                            fatherId: 5
                        },
                    },
                    {
                        path: "/talentRecruitment",
                        component: () => import("@/views/contact/TalentRecruitment.vue"),
                        meta: {
                            title: "人才招聘",
                            id: 14,
                            fatherId: 5
                        },
                    },
                ]
            },
        ]
    }
]

const router = new Router({
    routes: constantRouterMap
})
export default router